import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePropPipe } from '@pipes/translate-prop.pipe';

interface LocalizedText {
  nameKz: string;
  nameRu: string;
  nameQl: string;
  nameEn: string;
}

interface MaintenanceMessages {
  title: LocalizedText;
  body: LocalizedText;
  resumeDate: LocalizedText;
  actionClose: LocalizedText;
}

@Component({
  selector: 'app-maintenance-dialog',
  templateUrl: './maintenance-dialog.component.html',
  styleUrls: ['./maintenance-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslatePropPipe],
})
export class MaintenanceDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<MaintenanceDialogComponent>);

  readonly messages: MaintenanceMessages = {
    title: {
      nameKz: 'Техникалық жұмыстар',
      nameRu: 'Технические работы',
      nameQl: 'Tehnıkalyq jumystar',
      nameEn: 'Technical Maintenance',
    },
    body: {
      nameKz:
        '22.10.2026 сағат 20:00-ден 23.10.2026 сағат 08:00-ге дейін порталда техникалық жұмыстар жүргізіледі. Бұл уақытта портал уақытша қолжетімсіз болуы мүмкін.',
      nameRu:
        'С 20:00 22.10.2026 до 08:00 23.10.2026 на портале проводятся технические работы. В этот период портал может быть временно недоступен.',
      nameQl:
        '22.10.2026 saǵat 20:00-den 23.10.2026 saǵat 08:00-ge deıin portalda tehnıkalyq jumystar júrgiziledi. Bul ýaqytta portal ýaqytsha qoljetimsiz bolýy múmkin.',
      nameEn:
        'Technical maintenance will be carried out on the portal from 20:00 on 22.10.2026 to 08:00 on 23.10.2026. The portal may be temporarily unavailable during this period.',
    },
    resumeDate: {
      nameKz: 'Портал 23.10.2026 сағат 08:00-ден бастап қалыпты режимде жұмыс істейді.',
      nameRu: 'Портал возобновит работу в штатном режиме с 08:00 23.10.2026.',
      nameQl: 'Portal 23.10.2026 saǵat 08:00-den bastap qalypty rejımde jumys isteıdi.',
      nameEn: 'The portal will resume normal operation from 08:00 on 23.10.2026.',
    },
    actionClose: {
      nameKz: 'Түсінікті',
      nameRu: 'Понятно',
      nameQl: 'Túsinikti',
      nameEn: 'Got it',
    },
  };

  close(): void {
    this.dialogRef.close();
  }
}
